import { render, staticRenderFns } from "./typingFirst.vue?vue&type=template&id=1c642d10&"
import script from "./typingFirst.vue?vue&type=script&lang=js&"
export * from "./typingFirst.vue?vue&type=script&lang=js&"
import style0 from "./typingFirst.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports